import Confirm from './../../components/confirm';

const plugin = {
	install(Vue, props = {}) {
		const ConfirmPlugin = Vue.extend(Confirm);

		let $vm = new ConfirmPlugin({
			el: document.createElement('div')
		});
		document.body.appendChild($vm.$el);

		function confirm(options = {}) {
			if ($vm.show) return;

			if (typeof options === 'string') {
				options = {
					text: arguments[0]
				};
			}
			//配置优选级：实例配置 > 全部配置 > 默认配置
			$vm = Object.assign($vm, props, options);

			$vm.show = true;

			$vm.$off('on-confirm');
			$vm.$off('on-cancel');

			return new Promise((resolve, reject) => {
				$vm.$on('on-confirm', () => {
					resolve(true);
				});
				$vm.$on('on-cancel', () => {
					resolve(false);
				});
			});
		}

		if (!Vue.$v5) {
			Vue.$v5 = {
				confirm
			};
		} else {
			Vue.$v5.confirm = confirm;
		}
		Vue.mixin({
			created: function () {
				this.$v5 = Vue.$v5;
			}
		});
	}
};

export default plugin;



// WEBPACK FOOTER //
// ./~/@58fe/v5/src/plugins/confirm/index.js